

import Question from '../../views/questions/Question.vue'
import QuestionConditions from '../../views/questions/QuestionConditions.vue'
import QuestionCondition from '../../views/questions/QuestionCondition.vue'
import QuestionGeneral from '../../views/questions/QuestionGeneral.vue'
import QuestionTranslations from '../../views/questions/QuestionTranslations.vue'
import QuestionColumns from '../../views/questions/QuestionColumns.vue'
import QuestionColumn from '../../views/questions/QuestionColumn.vue'
import QuestionOptions from '../../views/questions/QuestionOptions.vue'
import QuestionBooleanOptions from '../../views/questions/QuestionBooleanOptions.vue'
import QuestionOption from '../../views/questions/QuestionOption.vue'
import QuestionClassIndices from '../../views/questions/QuestionClassIndices.vue'

import {roleSystemRoute} from './route_utilities'

export const question =  {
      path: 'question/:id',  
      name: 'Question',
      component: Question,
      redirect: { name: 'QuestionGeneral' },
      meta: {
          title: "soru",
          preloader:true,
          domain:"questionlists",
          accessroles:["admin","brand","auditor","planner"],
        },
        children:[
          {
          path: 'general',  
          name: 'QuestionGeneral',
          component: QuestionGeneral,
          meta: {
              title: "genel",
              preloader:true,
              domain:"questionlists",
              accessroles:["admin","brand","auditor","planner"],
            },
          },
          {
          path: 'translations',  
          name: 'QuestionTranslations',
          component: QuestionTranslations,
          meta: {
              title: "ceviriler",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'options',  
          name: 'QuestionOptions',
          component: QuestionOptions,
          meta: {
              title: "secenekler",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'boolean_options',  
          name: 'QuestionBooleanOptions',
          component: QuestionBooleanOptions,
          meta: {
              title: "secenekler",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'option/:option_id?',  
          name: 'QuestionOption',
          component: QuestionOption,
          meta: {
              title: "soru_secenegi",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'columns',  
          name: 'QuestionColumns',
          component: QuestionColumns,
          meta: {
              title: "sutunlar",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'class_factors',  
          name: 'QuestionClassIndices',
          component: QuestionClassIndices,
          meta: {
              title: "sinif_faktorleri",
              preloader:true,
              domain:"questionlists"
            },
          },
           {
          path: 'column/:column_id?',  
          name: 'QuestionColumn',
          component: QuestionColumn,
          meta: {
              title: "soru_sutunu",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'conditions',  
          name: 'QuestionConditions',
          component: QuestionConditions,
          meta: {
              title: "soru_kosullari",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'condition/:condition_id?',  
          name: 'QuestionCondition',
          component: QuestionCondition,
          meta: {
              title: "soru_kosulu",
              preloader:true,
              domain:"questionlists"
            },
          },
          
        ]
      }